import { render, staticRenderFns } from "./Base_Type1.vue?vue&type=template&id=e13fc3a0&scoped=true"
import script from "./Base_Type1.vue?vue&type=script&lang=js"
export * from "./Base_Type1.vue?vue&type=script&lang=js"
import style0 from "./Base_Type1.vue?vue&type=style&index=0&id=e13fc3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13fc3a0",
  null
  
)

export default component.exports